<template>
  <router-view :route="viewRoute" v-slot="{ Component }">
    <keep-alive include="MobileTrendList">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>

<script>
export default {
  name: "MobileTrend",
  data() {
    return { feedState: { needsRefresh: false } };
  },
  provide() {
    return { mobileTrendState: this.feedState };
  },
  computed: {
    viewRoute() {
      const route = this.$route;
      // 缓存容器仍会观察全局路由，离开动态分支时禁止渲染其他页面的子路由。
      return route.path.startsWith("/m/home/trend/") ? route : { ...route, matched: [] };
    },
  },
}
</script>

<style>
</style>
